import { ValueFormatterParams } from 'ag-grid-community';

export function emailFormatter(params: ValueFormatterParams): string {
  let val = _.get(params.data, params.colDef.field);
  return val ? `<div class="inner-cell"><a href="mailto:${val}">${val}</a></div>` : '';
}
